export const InputIconEyeActive = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20.742" height="21.394" viewBox="0 0 26.742 17.394">
            <path id="Icon_awesome-eye" data-name="Icon awesome-eye" d="M24.008,11.939A13.45,13.45,0,0,0,12.077,4.5,13.452,13.452,0,0,0,.146,11.94a1.357,1.357,0,0,0,0,1.224A13.45,13.45,0,0,0,12.077,20.6a13.452,13.452,0,0,0,11.931-7.44A1.357,1.357,0,0,0,24.008,11.939ZM12.077,18.59a6.039,6.039,0,1,1,6.039-6.039A6.039,6.039,0,0,1,12.077,18.59Zm0-10.064a4,4,0,0,0-1.061.159A2.007,2.007,0,0,1,8.21,11.49a4.016,4.016,0,1,0,3.867-2.964Z" transform="translate(0 -4.5)" fill="#3A913F"/>
        </svg>

    )
}

export const InputIconEyeInactive = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20.742" height="21.394" viewBox="0 0 26.742 21.394">
            <path id="Icon_awesome-eye-slash" data-name="Icon awesome-eye-slash" d="M13.371,16.713A5.994,5.994,0,0,1,7.4,11.152L3.017,7.764a13.926,13.926,0,0,0-1.534,2.323,1.352,1.352,0,0,0,0,1.22,13.4,13.4,0,0,0,11.888,7.412,12.979,12.979,0,0,0,3.255-.437L14.457,16.6A6.022,6.022,0,0,1,13.371,16.713Zm13.113,2.428-4.619-3.57a13.841,13.841,0,0,0,3.395-4.265,1.352,1.352,0,0,0,0-1.22A13.4,13.4,0,0,0,13.371,2.674,12.876,12.876,0,0,0,7.215,4.249L1.9.141A.669.669,0,0,0,.961.258L.141,1.314a.669.669,0,0,0,.117.938l24.584,19a.669.669,0,0,0,.938-.117l.821-1.056a.669.669,0,0,0-.118-.938Zm-7.677-5.933-1.642-1.269a3.959,3.959,0,0,0-4.852-5.095A1.991,1.991,0,0,1,12.7,8.022a1.949,1.949,0,0,1-.064.418L9.562,6.063A5.946,5.946,0,0,1,13.371,4.68,6.014,6.014,0,0,1,19.388,10.7a5.874,5.874,0,0,1-.581,2.512Z" transform="translate(0 0)" fill="#707070"/>
        </svg>
    )
}

export const ButtonPrevious = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 35 35" style={{ cursor: 'pointer' }}>
            <g id="Grupo_8199" data-name="Grupo 8199" transform="translate(22684.281 20275.281)">
                <path id="Trazado_15019" data-name="Trazado 15019" d="M-22670.5-20273.113l-5.971,5.973,5.971,5.973" transform="translate(6.386 9.87)" fill="none" stroke="#3A913F" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <g id="Elipse_192" data-name="Elipse 192" transform="translate(-22684.281 -20275.281)" fill="none" stroke="#3A913F" stroke-width="2">
                    <circle cx="17.5" cy="17.5" r="17.5" stroke="none"/>
                    <circle cx="17.5" cy="17.5" r="16.5" fill="none"/>
                </g>
            </g>
        </svg>
    )
}

export const ButtonNext = () => {
    return (
        <svg id="Grupo_8744" data-name="Grupo 8744" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 35 35" style={{ cursor: 'pointer' }}>
            <path id="Trazado_15019" data-name="Trazado 15019" d="M-22676.469-20273.113l5.971,5.973-5.971,5.973" transform="translate(22691.301 20285.15)" fill="none" stroke="#3A913F" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <g id="Elipse_192" data-name="Elipse 192" fill="none" stroke="#3A913F" stroke-width="2">
                <circle cx="17.5" cy="17.5" r="17.5" stroke="none"/>
                <circle cx="17.5" cy="17.5" r="16.5" fill="none"/>
            </g>
        </svg>

    )
}